import { type FC } from 'react';
import { selectFactoryUpgradeData } from '@redux/selectors/factoryReducer';
import { useAppSelector } from '@redux/store';

import { type CompateItemProps } from '@/common/types/components';

import { CompateItem } from './CompareItem';

interface FactoryUpgradeInfoProps {
  id?: string;
  withoutNext?: boolean;
  list?: CompateItemProps[];
}

const FactoryUpgradeInfo: FC<FactoryUpgradeInfoProps> = ({
  id,
  withoutNext,
  list,
}) => {
  const compaireOptions = useAppSelector((state) =>
    selectFactoryUpgradeData(state, id),
  );

  return (
    <div className="w-full flex justify-around mb-9">
      {(list || compaireOptions)?.map((props) => (
        <CompateItem key={props.kind} {...props} withoutNext={withoutNext} />
      ))}
    </div>
  );
};

export { FactoryUpgradeInfo };
